module.exports = __webpack_public_path__ + "img/cancelado_b.edb5097c.png";